import { BaseApiClient } from './BaseApiClient';
import { IApiInterface } from './IApiConfig';
import { IAuthTokenBuilder } from './IAuthTokenBuilder';

export class BaitYourBuddyClient extends BaseApiClient {
  private logger: any;

  public constructor(config: IApiInterface, fetch: any, logger: any, authTokenBuilder: IAuthTokenBuilder) {
    super(config, fetch, authTokenBuilder);
    this.logger = logger || (() => { /* no-op */ });
  }

  public baitYourBuddy = async (buddyEmail: string, buddyName: string): Promise<boolean> => {
    this.logger('[BaitYourBuddyService] baiting ' + buddyEmail);

    try {
      const data = {
        to: buddyEmail,
        name: buddyName,
      };

      const request = await this.buildPostRequest('api/bait', data);
      const result = await this.fetch(request.url, request.options);
      const response = await this.assertHttp200AndGetJsonFromResult(result);
      this.logger('[BaitYourBuddyService] bait results', response);

      return response.success;
    } catch (err) {
      this.logger('[BaitYourBuddyService] failed to bait your buddy', err);
      return false;
    }
  }
}
